import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7207 22.2254C12.174 22.2254 11.7207 21.7721 11.7207 21.2254V16.7055L11.4674 16.9854C11.094 17.3988 10.4674 17.4254 10.054 17.0654C9.6407 16.6921 9.61404 16.0654 9.97404 15.6521L11.974 13.4255C12.254 13.1188 12.694 13.0121 13.0807 13.1588C13.4674 13.3055 13.7207 13.6788 13.7207 14.0921V21.2254C13.7207 21.7854 13.2807 22.2254 12.7207 22.2254Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3613 6.96316C13.1346 6.96316 12.9213 6.89652 12.7346 6.73652C12.3079 6.38985 12.2413 5.7632 12.5746 5.33654L15.2146 2.04324C15.5613 1.61658 16.1879 1.54983 16.6146 1.88317C17.0413 2.2165 17.1079 2.85657 16.7746 3.28323L14.1346 6.57653C13.948 6.82986 13.6546 6.96316 13.3613 6.96316Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0018 30.3317C8.92179 30.3317 3.14844 24.5717 3.14844 17.4784C3.14844 14.7184 4.04179 12.065 5.74845 9.79834C6.08179 9.35834 6.70844 9.26506 7.14844 9.59839C7.58844 9.93172 7.6818 10.5584 7.34847 10.9984C5.90847 12.9184 5.14844 15.1584 5.14844 17.4784C5.14844 23.465 10.0151 28.3317 16.0018 28.3317C21.9885 28.3317 26.8551 23.465 26.8551 17.4784C26.8551 11.4917 21.9885 6.625 16.0018 6.625C15.2285 6.625 14.4418 6.71838 13.5885 6.91838C13.0551 7.03838 12.5085 6.70505 12.3885 6.17171C12.2685 5.63838 12.6018 5.09168 13.1351 4.97168C14.1351 4.74501 15.0818 4.625 16.0018 4.625C23.0818 4.625 28.8551 10.385 28.8551 17.4784C28.8551 24.5717 23.0818 30.3317 16.0018 30.3317Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6667 22.2271C16.64 22.2271 15 20.5871 15 18.5604V16.7604C15 14.7338 16.64 13.0938 18.6667 13.0938C20.6933 13.0938 22.3333 14.7338 22.3333 16.7604V18.5604C22.3333 20.5871 20.6933 22.2271 18.6667 22.2271ZM18.6667 15.1071C17.7467 15.1071 17 15.8538 17 16.7738V18.5737C17 19.4937 17.7467 20.2404 18.6667 20.2404C19.5867 20.2404 20.3333 19.4937 20.3333 18.5737V16.7738C20.3333 15.8538 19.5867 15.1071 18.6667 15.1071Z",
			fill: "white"
		})
	]
});
export default SvgBackward;
